import { Button, Group, Heading, Text } from '@optiaxiom/react';
import styles from './ApiKeyEmptyState.module.css';

interface ApiKeyErrorProps {
  onRetry: () => void;
  /** True while a retry is in flight. */
  retrying?: boolean;
}

/**
 * Shown when the API-key *status* request fails. Distinct from the empty state
 * on purpose: a failed fetch doesn't mean the developer has no key — so we must
 * not imply that — it just means we couldn't load it. Offers a retry.
 */
export function ApiKeyError({ onRetry, retrying = false }: ApiKeyErrorProps) {
  return (
    <Group alignItems="center" flexDirection="column" className={styles.container}>
      <Heading level="2" fontWeight="700" className={styles.title}>
        Couldn&rsquo;t load your API key
      </Heading>
      <Text color="fg.secondary" className={styles.body}>
        Something went wrong loading your API key status. If you already have a key, it&rsquo;s still
        active — this is just a problem fetching it. Please try again.
      </Text>
      <Button appearance="primary" onClick={onRetry} loading={retrying} disabled={retrying}>
        {retrying ? 'Retrying…' : 'Try again'}
      </Button>
    </Group>
  );
}
